import { Form, FormItem } from 'components/Base/Form';
import { useTranslation, SRequiredLabel } from '@packages/utils';
import { AutoComplete } from 'components/Base/AutoComplete';
import PlaceAutocomplete from 'components/Shared/PlaceAutocomplete';
import { useGetOrganizationsIdentityQuery } from 'redux/apiSlice/organizations.slice';
import { TCreateOrganizationFormProps } from './CreateOrganizationFrom.types';
import useGetFormData from './CreateOrganizationForm.data';

const CreateOrganizationForm = ({
  form,
  organizationData,
}: TCreateOrganizationFormProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.organizations.list.actions.add-organization.modal.form',
  });
  const { createOrganizationFormFields } = useGetFormData();
  const { address, name } = createOrganizationFormFields;
  const { data: organizations, isLoading: isLoadingOrganizations } =
    useGetOrganizationsIdentityQuery();

  // Map organizations to use label as value (for creating new orgs, we want the name not the ID)
  const organizationOptions = organizations?.map(org => ({
    label: org.label,
    value: org.label, // Use label as value so form gets the organization name
  }));

  return (
    <Form
      form={form}
      initialValues={{
        name: organizationData?.name || undefined,
        address: organizationData?.address?.formattedAddress || '',
      }}
    >
      <FormItem {...name}>
        <AutoComplete
          placeholder={name.placeholder}
          options={organizationOptions}
          loading={isLoadingOrganizations}
        />
      </FormItem>

      <SRequiredLabel>{t('address.LABEL')}</SRequiredLabel>
      <FormItem {...address}>
        <PlaceAutocomplete placeholder={address.placeholder} />
      </FormItem>
    </Form>
  );
};

export default CreateOrganizationForm;
